import { GetAllDataResponse } from "./articleContentData.interface";

const MOCK_UPDATE_DT = "2026-05-27T07:47:30Z";

const tc119Data = {
  text: {
    "Partner Axis": {
      "Partner A": [
        {
          "Partner A Name": {
            value: [{ text: "SpiroChem AG" }],
          },
          "Partner A Relationship Context": {
            value: [],
          },
        },
      ],
      "Partner A Responsibility & Rights": {
        value: [
          {
            text: "Provide its compound library and expertise in macrocycle, peptide, and peptoid chemistry",
          },
          {
            text: "Apply medicinal chemistry design, optimization, and data generation capabilities to the collaboration",
          },
          {
            text: "Work with Veritas In Silico Inc. to jointly commercialize research outcomes through partnerships, licensing arrangements, or co-development agreements",
          },
        ],
      },
      "Partner B": [
        {
          "Partner B Name": {
            value: [{ text: "Veritas In Silico Inc." }],
          },
          "Partner B Relationship Context": {
            value: [],
          },
        },
      ],
      "Partner B Responsibility & Rights": {
        value: [
          {
            text: "Provide its AI-driven mRNA-targeted drug discovery platform and cellular assay capabilities",
          },
          {
            text: "Provide selected mRNA targets discovered in-house for evaluation",
          },
          {
            text: "Work with SpiroChem AG to jointly commercialize research outcomes through partnerships, licensing arrangements, or co-development agreements",
          },
        ],
      },
      "Partner C": [
        {
          "Partner C Name": {
            value: [{ text: "Veritas In Silico Inc." }],
          },
          "Partner C Relationship Context": { value: [] },
        },
      ],
      "Partner C Responsibility & Rights": { value: [] },
    },
  },
  updateDt: MOCK_UPDATE_DT,
};

const tc120Data = {
  text: {
    "Licensee(MA)": [
      {
        "Licensee Name(MA)": {
          value: [{ text: "Veritas In Silico Inc." }],
        },
        "Licensee Relationship Context(MA)": { value: [] },
      },
    ],
    "Licensee Responsibility & Rights (MA)": {
      value: [
        {
          text: "Provide its AI-driven mRNA-targeted drug discovery platform and cellular assay capabilities",
        },
        {
          text: "Provide selected mRNA targets discovered in-house for evaluation",
        },
        {
          text: "Work with SpiroChem AG to jointly commercialize research outcomes through partnerships, licensing arrangements, or co-development agreements",
        },
      ],
    },
    "Licensor(MA)": [
      {
        "Licensor Name(MA)": {
          value: [{ text: "Veritas In Silico Inc." }],
        },
        "Licensor Relationship Context(MA)": { value: [] },
        "Licensor Partial Acquisition Subject(MA)": { value: [] },
      },
    ],
    "Licensor Responsibility & Rights": {
      value: [
        {
          text: "Provide its AI-driven mRNA-targeted drug discovery platform and cellular assay capabilities",
        },
        {
          text: "Provide selected mRNA targets discovered in-house for evaluation",
        },
        {
          text: "Work with SpiroChem AG to jointly commercialize research outcomes through partnerships, licensing arrangements, or co-development agreements",
        },
      ],
    },
  },
  updateDt: MOCK_UPDATE_DT,
};

const tc121Data = {
  text: {
    "Rights Scope Table": [
      {
        Asset: { value: [{ text: "mRNA-targeting small molecule compounds" }] },
        "Rights Scope Type": { value: [{ text: "Collaboration" }] },
        "Rights Scope": { value: [] },
        "Rights Flow": {
          "Contributing Axis": { value: [{ text: "A" }, { text: "B" }] },
          "Axis Direction": { value: [] },
          "Benefiting Axis": { value: [] },
        },
        "Rights Limitation": { value: [] },
        "Intended Use": { value: [{ text: "mRNA-targeted drug discovery" }] },
        Exclusivity: { value: [] },
        Territory: { value: [] },
        "Territory Include": { value: [] },
        "Territory Exclude": { value: [] },
      },
      {
        Asset: { value: [{ text: "mRNA-targeting small molecule compounds" }] },
        "Rights Scope Type": { value: [{ text: "Collaboration" }] },
        "Rights Scope": { value: [] },
        "Rights Flow": {
          "Contributing Axis": { value: [{ text: "A" }, { text: "B" }] },
          "Axis Direction": { value: [] },
          "Benefiting Axis": { value: [] },
        },
        "Rights Limitation": { value: [] },
        "Intended Use": { value: [{ text: "mRNA-targeted drug discovery" }] },
        Exclusivity: { value: [] },
        Territory: { value: [] },
        "Territory Include": { value: [] },
        "Territory Exclude": { value: [] },
      },
      {
        Asset: { value: [{ text: "mRNA-targeting small molecule compounds" }] },
        "Rights Scope Type": { value: [{ text: "Collaboration" }] },
        "Rights Scope": { value: [] },
        "Rights Flow": {
          "Contributing Axis": { value: [{ text: "A" }] },
          "Axis Direction": { value: [] },
          "Benefiting Axis": { value: [{ text: "B" }] },
        },
        "Rights Limitation": { value: [] },
        "Intended Use": { value: [{ text: "mRNA-targeted drug discovery" }] },
        Exclusivity: { value: [] },
        Territory: { value: [] },
        "Territory Include": { value: [] },
        "Territory Exclude": { value: [] },
      },
    ],
  },
  updateDt: MOCK_UPDATE_DT,
};

const tc122Data = {
  text: {
    "Rights Scope": [
      {
        Drug: { value: [{ text: "mRNA-targeting compounds" }] },
        Indication: { value: [] },
        Exclusivity: { value: [] },
        Territory: { value: [] },
      },
    ],
  },
  updateDt: MOCK_UPDATE_DT,
};

const tc123Data = {
  text: {
    "Main Financial Terms Table": [
      {
        "Paying Partner Axis(LA&SC)": { value: [] },
        "Receiving Partner Axis(LA&SC)": { value: [] },
        "Upfront Payment(LA&SC)": { value: [] },
        "Royalty(LA&SC)": [
          {
            "Royalty Rate": { value: [] },
            "Royalty Detail": { value: [] },
          },
        ],
        "Total Payment(LA&SC)": { value: [] },
        "Disclosed Payment Sum(LA&SC)": { value: [] },
        "Milestone Payment And Detail": [
          {
            "Milestone Payment(LA&SC)": { value: [] },
            "Milestone Payment Detail(LA&SC)": { value: [] },
          },
        ],
        "Other Payment And Detail": [
          {
            "Other Payment(LA&SC)": { value: [] },
            "Other Payment Detail(LA&SC)": { value: [] },
          },
        ],
      },
    ],
    "Other Financial Terms": {
      value: [
        {
          text: "No upfront payments or similar income are anticipated in connection with the execution of the Agreement.",
        },
        {
          text: "222 No upfront payments or similar income are anticipated in connection with the execution of the Agreement.",
        },
      ],
    },
  },
  updateDt: MOCK_UPDATE_DT,
};

const tc124Data = {
  text: {
    "Merge & Acquisition terms": {
      "Licensee Responsibility & Rights (MA)": { value: [] },
      "Number of acquiring shares": { value: [] },
      "Price Per Share": { value: [] },
      "Total Payment (MA)": { value: [] },
      "Upfront Payment (MA)": { value: [] },
      "Upfront Price Per Share (MA)": { value: [] },
      "Contingent Payment": [
        {
          "Contingent Payment (MA)": { value: [] },
          "Contingent Price per share (MA)": { value: [] },
          "Contingent Milestone (MA)": { value: [] },
        },
      ],
      "Merger Financial Terms (MA)": { value: [] },
      "Other Financial Terms (MA)": { value: [] },
      "Disclosed Payments Sum (MA)": { value: [] },
      "Disclosed Payments Sum Price Per Share (MA)": { value: [] },
    },
  },
  updateDt: MOCK_UPDATE_DT,
};

const tc125Data = {
  text: {
    "Deal Structure": {
      "Mechanical Structure": { value: [] },
      "Structural Tags": { value: [] },
      "Structural Notes": { value: [] },
    },
  },
  updateDt: MOCK_UPDATE_DT,
};

const tc126Data = {
  text: {
    "Key Comment List": [
      {
        "Comment Quote": { value: [] },
        "Comment Spokesperson": { value: [] },
      },
    ],
  },
  updateDt: MOCK_UPDATE_DT,
};

const MOCK_DATA_MAP: Record<string, unknown> = {
  // TC119: tc119Data,
  // TC120: tc120Data,
  // TC121: tc121Data,
  // TC122: tc122Data,
  // TC123: tc123Data,
  // TC124: tc124Data,
  // TC125: tc125Data,
  // TC126: tc126Data,
};

export const MOCK_PARAGRAPH_CODES = new Set(Object.keys(MOCK_DATA_MAP));

export const getMockAllArticleData = (
  paragraphCode: string,
): GetAllDataResponse => {
  const content = MOCK_DATA_MAP[paragraphCode];
  const stringified = JSON.stringify(content);

  return {
    code: 200,
    message: "success",
    data: {
      draftArticleId: 0,
      itemId: paragraphCode,
      data: stringified,
      editedData: stringified,
      procStatus: 1,
      createDt: MOCK_UPDATE_DT,
      updateDt: MOCK_UPDATE_DT,
      writerEmail: "",
    },
  };
};
